"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Table_styles_1 = __importDefault(require("./Table.styles"));
function Table(_a) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.striped, striped = _c === void 0 ? false : _c, _d = _a.highlightOnHover, highlightOnHover = _d === void 0 ? false : _d, themeOverride = _a.themeOverride, _e = _a.captionSide, captionSide = _e === void 0 ? 'top' : _e, others = __rest(_a, ["className", "children", "striped", "highlightOnHover", "themeOverride", "captionSide"]);
    var classes = Table_styles_1.default({ captionSide: captionSide, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement("table", __assign({}, others, { className: clsx_1.default(classes.table, (_b = {}, _b[classes.striped] = striped, _b[classes.hover] = highlightOnHover, _b), className) }), children));
}
exports.Table = Table;
Table.displayName = '@mantine/core/Table';
